var _path, _path2, _path3, _path4, _path5, _path6, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg62B0B19Dbc5F55C4206158F7ChooseYourMeals1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 118,
    viewBox: "0 0 151 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.544 98.0591H12.6319C11.4136 98.0591 10.426 97.0715 10.426 95.8532V23.0611C10.426 20.6261 12.3988 18.6516 14.8338 18.6494L127.334 18.5477C129.772 18.5455 131.75 20.5214 131.75 22.9595V95.8532C131.75 97.0715 130.762 98.0591 129.544 98.0591Z",
    fill: "white",
    stroke: "#03514E",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.927 89.2355H19.2502V27.5558L122.927 27.4706V89.2355Z",
    fill: "#85E5C6",
    stroke: "#03514E",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.264 98.059H4.91121C3.69293 98.059 2.70532 99.0466 2.70532 100.265V106.643C2.70532 106.769 5.14476 106.871 8.14715 106.871L134.029 106.883C137.031 106.883 139.47 106.781 139.47 106.655V100.265C139.47 99.0466 138.483 98.059 137.264 98.059Z",
    fill: "white",
    stroke: "#03514E",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.677 1C141.677 1 141.677 9.82355 150.5 9.82355C150.5 9.82355 141.677 9.82355 141.677 18.6471C141.677 18.6471 141.677 9.82355 132.853 9.82355C132.853 9.82355 141.677 9.82355 141.677 1Z",
    stroke: "#FF621C",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.500244 115.706H141.677",
    stroke: "#85E5C6",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_188_6054",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 29,
    width: 100,
    height: 59
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.72 87.0296H21.4553V29.7556L120.72 29.6766V87.0296Z",
    fill: "#85E5C6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_188_6054)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.499,
    y: 36.2942,
    width: 38.603,
    height: 24.2648,
    rx: 2,
    fill: "#85E5C6",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.499,
    y: 69.3825,
    width: 38.603,
    height: 24.2648,
    rx: 2,
    fill: "#85E5C6",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.0735,
    y: 36.2942,
    width: 38.603,
    height: 24.2648,
    rx: 2,
    fill: "#85E5C6",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.0735,
    y: 69.3825,
    width: 38.603,
    height: 24.2648,
    rx: 2,
    fill: "#85E5C6",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.0745,
    y: 36.2942,
    width: 38.603,
    height: 24.2648,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3096 46.8037L46.0523 51.7354L54.5449 42.9118",
    stroke: "#03514E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.0745,
    y: 69.3825,
    width: 38.603,
    height: 24.2648,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3096 79.8921L46.0523 84.8237L54.5449 76.0002",
    stroke: "#03514E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.5005,
    y: 36.2942,
    width: 38.603,
    height: 24.2648,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7358 46.8037L93.4786 51.7354L101.971 42.9118",
    stroke: "#03514E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.5005,
    y: 69.3825,
    width: 38.603,
    height: 24.2648,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7358 79.8921L93.4786 84.8237L101.971 76.0002",
    stroke: "#03514E",
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg62B0B19Dbc5F55C4206158F7ChooseYourMeals1);
export default __webpack_public_path__ + "static/media/62b0b19dbc5f55c4206158f7_choose-your-meals (1).d7eb577ce7d741407d19dada28e9a7a3.svg";
export { ForwardRef as ReactComponent };